// extracted by mini-css-extract-plugin
export var list = "listCases-module--list--os9iX";